module.exports = __webpack_public_path__ + "static/media/SummaryCh8_A01378565.8250082f.pdf";